import { Segmented, type SegmentedOption } from '@/ui'
import { platformLabel, WINDOWS, windowHint, windowLabel } from './format'

/** The window, 24시간 · 3일 · 7일 · 30일 · 90일. Shared by the list and the
 *  per-app panel so the two cannot offer different windows. */
export function WindowPicker({ days, onChange }: { days: number; onChange: (d: number) => void }) {
  const options: SegmentedOption<string>[] = WINDOWS.map((d) => ({ value: String(d), label: windowLabel(d), title: windowHint(d) }))
  // An address can carry a window the buttons do not offer; keep it visible.
  if (!WINDOWS.includes(days)) options.push({ value: String(days), label: windowLabel(days) })
  return <Segmented label="기간" options={options} value={String(days)} onChange={(v) => onChange(Number(v))} />
}

/** The platform filter. `app_id` is one string per PRODUCT, so every figure on
 *  both screens is a cross-platform sum until one of them says otherwise; a
 *  control on the list but not on the detail page would answer "iOS had one
 *  user" and, one click later, "nine".
 *
 *  `options` come from the response rather than a fixed list: an iOS button
 *  with nothing behind it is worse than none. While a newly chosen platform
 *  loads they can be momentarily empty, so the active choice stays in the list
 *  and the picker stays while one is set. */
export function PlatformPicker({
  platform,
  options,
  onChange,
}: {
  platform: string
  options: string[]
  onChange: (p: string) => void
}) {
  const opts = platform && !options.includes(platform) ? [platform, ...options] : options
  if (opts.length < 2 && !platform) return null
  const items: SegmentedOption<string>[] = [
    { value: '', label: '전체', title: '모든 플랫폼의 합' },
    ...opts.map((p) => ({ value: p, label: platformLabel(p), title: `${platformLabel(p)} 설치만` })),
  ]
  return <Segmented label="플랫폼" options={items} value={platform} onChange={onChange} />
}
